import brownCat from '../../../assets/1BrownCat.png';
import whiteCat from '../../../assets/2WhiteCat.png';
import blackCat from '../../../assets/3BlackCat.png';
import orangeCat from '../../../assets/4OrangeCat.png';
import greyCat from '../../../assets/5GreyCat.png';
import calicoCat from '../../../assets/6CalicoCat.png';
import siameseCat from '../../../assets/7SiameseCat.png';
import brownCatSelected from '../../../assets/1BrownCatSelected1.gif';
import whiteCatSelected from '../../../assets/2WhiteCatSelected.gif';
import blackCatSelected from '../../../assets/3BlackCatSelected.gif';
import orangeCatSelected from '../../../assets/4OrangeCatSelected.gif';
import greyCatSelected from '../../../assets/5GreyCatSelected.gif';
import calicoCatSelected from '../../../assets/6CalicoCatSelected.gif';
import siameseCatSelected from '../../../assets/7SiameseCatSelected.gif';
import ruleImage1 from '../../../assets/optimized/ruleImage1Optimized.png';
import ruleImage2 from '../../../assets/optimized/ruleImage2Optimized.png';
import ruleImage1webp from '../../../assets/optimized/ruleImage1Optimized.webp';
import ruleImage2webp from '../../../assets/optimized/ruleImage2Optimized.webp';

const catImageMap = [brownCat, whiteCat, blackCat, orangeCat, greyCat, calicoCat, siameseCat];
const catImageSelectedMap = [brownCatSelected,
  whiteCatSelected,
  blackCatSelected,
  orangeCatSelected,
  greyCatSelected,
  calicoCatSelected,
  siameseCatSelected];

export {
  catImageMap, catImageSelectedMap, ruleImage1, ruleImage2, ruleImage1webp, ruleImage2webp,
};
